import { produce } from 'immer'
import reducerUtils from './reducerUtils'

export const AuthActions = {
  SET_STATUS: 'auth/setStatus',
  SET_SESSION: 'auth/setSession',
  CLEAR: 'auth/clear',
}

// status: 'loading' | 'anon' | 'mfa' (signed in, two-factor pending) | 'ready'
const initialState = {
  status: 'loading',
  user: null,
  mfa: { verified: false, enrolled: false },
  settings: { idleTimeoutMinutes: 15, requiredDocuments: [] },
  config: {},
  csrfToken: '',
  expiredNotice: false,
}

export const authSelectors = {
  status: (s) => s.auth.status,
  user: (s) => s.auth.user,
  settings: (s) => s.auth.settings,
  config: (s) => s.auth.config,
  mfa: (s) => s.auth.mfa,
  expiredNotice: (s) => s.auth.expiredNotice,
  can: (s, perm) => !!s.auth.user && s.auth.user.permissions.includes(perm),
}

const handlers = {
  [AuthActions.SET_STATUS]: produce((draft, a) => {
    draft.status = a.status
  }),
  [AuthActions.SET_SESSION]: produce((draft, a) => {
    draft.user = a.me.user
    draft.mfa = a.me.mfa
    draft.settings = a.me.settings
    draft.config = a.me.config
    draft.csrfToken = a.me.csrfToken
    draft.expiredNotice = false
    draft.status = a.me.mfa.verified ? 'ready' : 'mfa'
  }),
  [AuthActions.CLEAR]: produce((draft, a) => {
    Object.assign(draft, initialState, { status: 'anon', expiredNotice: !!a.expired })
  }),
}

export default reducerUtils.createReducer(initialState, handlers)
